import React from 'react';
import { InputNumber as AntdInputNumber } from 'antd';
import { ErrorMessage } from '../index';

const InputNumber = ({
  value = '',
  placeholder = '',
  onChange = () => {},
  label = '',
  errorMsg = '',
  icon = <></>,
  onBlur = () => {},
}) => {
  return (
    <>
      <div>{icon}</div>
      <h3>{label}</h3>
      <AntdInputNumber
        placeholder={placeholder}
        onChange={onChange}
        style={{
          width: 200,
        }}
        value={value}
        onBlur={onBlur}
      />
      <ErrorMessage errorMsg={errorMsg} />
    </>
  );
};

export default InputNumber;
